import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { qpRequiredMisc } from "../../utils/misc";
import "./SiSu.css";
import { actionCreators } from '../../store/AccountStore';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            repassword: '',
            submitted: false,
            loading: false,
            error: '',
            code: null,
            isProcessing: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.saveNewPassword = this.saveNewPassword.bind(this);
    }

    componentDidMount() {
        qpRequiredMisc();
        this.props.clearUser();
        if (this.props.location.search !== "") {
            const search = this.props.location.search;
            const params = new URLSearchParams(search);
            const codel = params.get('code');
            const maill = params.get('email');
            this.setState({ code: codel, email: maill })

        }
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value })

    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email, password } = this.state;
        if (!(email && password)) {
            return;
        }
        this.setState({ loading: true });
        this.props.requestAccountLogin(email, password).then(
            user => {

                user.statusCode === 300 ? this.setState({ error: user.text.replace(/["']/g, ""), loading: false, email: '', password: '' }) : this.props.redirectToHome();

                user.statusCode === 350 ? this.setState({ error: user.text.replace(/["']/g, ""), loading: false, password: '' }) : this.props.redirectToHome();

            }
        );
    }

    forgotPassword() {
        this.setState({ isProcessing: true }, () => {
            this.props.forgotPassword(this.state.email).then(
                result => {
                    this.setState({ isProcessing: this.props.isProcessing }, () => {
                        document.getElementById("hideModal").click();

                    })
                },
                error => {
                    console.log('error', error)
                }
            );
        })
    }

    saveNewPassword(e) {
        e.preventDefault();
        this.setState({ loading: true });
        if (this.state.password === this.state.repassword) {
            this.props.saveNewPassword(this.state.code, this.state.email, this.state.password).then(
                result => {
                    console.log("success", result)
                },
                error => console.log("error")
            );
        }
    }

    form() {
        if (this.state.code === null) {
            return (
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input
                            type="email"
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter email"
                            name="email" value={this.state.email || ""} onChange={this.handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="exampleInputPassword1"
                            placeholder="Password"
                            name="password" value={this.state.password || ""} onChange={this.handleChange}
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary btn-block"
                    >
                        <i className="batch-icon batch-icon-key" />
                        Sign In
                                     </button>
                    <label
                        className="btn btn-secondary btn-block"
                        data-toggle="modal"
                        data-target="#exampleModalCenter"
                    >
                        Forgot Password?
                                     </label>
                    <div
                        className="modal fade"
                        id="exampleModalCenter"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalCenterTitle"
                        aria-hidden="true"
                    >
                        <div
                            className="modal-dialog modal-dialog-centered"
                            role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5
                                        className="modal-title"
                                        id="exampleModalLongTitle">
                                        Reset Password
                                                    </h5>
                                    <button
                                        id="hideModal"
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <label >Email address</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="FPInputEmail"
                                        aria-describedby="emailHelp"
                                        placeholder="Enter email"
                                        name="email" value={this.state.email || ""} onChange={this.handleChange}
                                    />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => this.forgotPassword()}
                                        disabled={this.state.isProcessing}
                                        style={{ textDecoration: "none" }}
                                    >
                                        {this.state.isProcessing ? "Sending" : "Send Email"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            )
        }
        else {
            return (
                <form onSubmit={this.saveNewPassword}>
                    <div className="form-group">
                        <label htmlFor="password">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="exampleInputPassword1"
                            placeholder="Password"
                            name="password" value={this.state.password || ""} onChange={this.handleChange}
                        />
                        {this.state.password !== "" && this.state.password.length < 6 ? <div className={'alert alert-danger'}><i className="batch-icon batch-icon-cross" style={{ color: "red", marginTop: 5 }} />Password length must be least 6 characters </div> : null}
                    </div>
                    <div className="form-group">
                        <label htmlFor="reEnterPassword">Re-Enter New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="exampleInputPassword2"
                            placeholder="Password"
                            name="repassword" value={this.state.repassword || ""} onChange={this.handleChange} />
                        {this.state.password !== this.state.repassword ? this.state.repassword !== "" ? <div className={'alert alert-danger'}><i className="batch-icon batch-icon-cross" style={{ color: "red", marginTop: 5 }} />PASSWORD MUST MATCH</div>
                            : null : null}
                    </div>
                    <button
                        type="submit"
                        className=" btn btn-success btn-block"
                        disabled={this.state.password === this.state.repassword && this.state.password.length >= 6 && this.state.loading === false ? false : true}

                    >
                        <i className="batch-icon batch-icon-stiffy" />
                        Save New Password
                                     </button>

                </form>
            )
        }
    }

    render() {
        const { error } = this.state;
        return (
            <div className="container-fluid">
                <ToastContainer autoClose={3000} />
                <div className="row">
                    <div className="right-column sisu">
                        <div className="row mx-0">
                            <div className="col-md-7 order-md-2 signin-right-column px-5 bg-dark">
                                <a className="signin-logo d-sm-block d-md-none" to="#!">
                                    <img
                                        src="assets/img/minayla_mini_logo_white_small.png"
                                        alt="Minayla"
                                        style={{ width: "50%", height: "100%" }}
                                    />
                                </a>
                                <h1 className="display-4">Sign In To get Started</h1>
                                <p className="lead mb-5">
                                    Minayla
                </p>
                            </div>
                            <div className="col-md-5 order-md-1 signin-left-column bg-white px-5">
                                <a className="signin-logo d-sm-none d-md-block" to="#!">
                                    <img
                                        src="assets/img/minayla_mini_logo_black_small.png"
                                        alt="Minayla"
                                        style={{ width: "50%", height: "100%", marginLeft: "25%" }}
                                    />
                                </a>
                                {this.form()}
                                {error &&
                                    <div className={'alert alert-danger'}>{error}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => state.account,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Login);


// WEBPACK FOOTER //
// ./src/view/Account/Account.js